import { FC } from 'react';
import { Snackbar as MuiSnackbar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import MuiAlert from '@mui/lab/Alert';
import { TAlertTypes } from '../../../interfaces/snackBar';

interface IAlert {
  snackbarMsg?: string;
  onClose: () => void;
  severity?: TAlertTypes;
  children?: string;
}
const Alert: FC<IAlert> = props => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

interface ISnackbar {
  open: boolean;
  alertType: TAlertTypes;
  snackbarMsg: string;
  handleClose: () => void;
}

const Snackbar: FC<ISnackbar> = ({
  handleClose,
  open,
  snackbarMsg,
  alertType,
}) => {
  const classes = useStyles();

  const renderAlert = (alertType: TAlertTypes) => ({
    [alertType]: (handleClose: () => void, snackbarMsg: string) => (
      <Alert onClose={handleClose} severity={alertType}>
        {snackbarMsg}
      </Alert>
    ),
  });

  return (
    <div className={classes.root}>
      <MuiSnackbar
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div>{renderAlert(alertType)[alertType](handleClose, snackbarMsg)}</div>
      </MuiSnackbar>
    </div>
  );
};

export default Snackbar;
